import React, { useEffect, useState } from 'react'
import styled from 'styled-components'
import { Box } from '@material-ui/core'

import Back from 'assets/images/nft/wallpaper.png'
import BackMobile from 'assets/images/character/mobile_back.png'
import Char1 from 'assets/images/character/1.png'
import Char2 from 'assets/images/character/2.png'
import Char3 from 'assets/images/character/3.png'
import Button1 from 'assets/images/token/join.png'
import useWindowDimensions from 'hooks/useDimensions'
import Snowfall from 'react-snowfall'
// import { useHistory } from 'react-router'

const CharCard: React.FC = () => {
    const screenWidth = useWindowDimensions().width
    const [isMobile, setIsMobile] = useState(false)
    // const history = useHistory()

    useEffect(() => {
        screenWidth > 1100 ? setIsMobile(false) : setIsMobile(true)
    }, [screenWidth])
    return (
        <StyledContainer>
            {!isMobile && <OlafText>Characters Cards</OlafText>}
            <SantaBox>
                <Box><img src={Char1} alt='' /></Box>
                <Box><img src={Char2} alt='' /></Box>
                <Box><img src={Char3} alt='' /></Box>
            </SantaBox>
            <Box display='flex' justifyContent='center'>
                <JoinButton component='img' {...{ src: Button1 }} onClick={() => window.open('https://forms.gle/iwBvomru7fupQxKq7')} />
            </Box>
            <Snowfall />
        </StyledContainer>
    )
}

const SantaBox = styled(Box)`
    display: flex;
    justify-content: center;
    align-items: flex-start;
    >div+div {
        margin-left: 94.58px;
        margin-top: 0;
        @media (max-width: 1100px) {
            margin-left: 0 !important;
            margin-top: 42.34px !important;
        }
    }
    @media (max-width: 1100px) {
        flex-direction: column;
        align-items: center;
    }
    >div:nth-of-type(2) {
        margin-top: 15.13px;
    }
`

const JoinButton = styled(Box)`
    position: relative;
    cursor: pointer;
    pointer-events: initial;
    margin-top: 56.21px;
    margin-bottom: 48px;
    @media (max-width: 767px) {
        margin-top: 57.47px;
        margin-bottom: 34px;
    }
    height: 84px;
`

const OlafText = styled(Box)`
    font-weight: bold;
    font-size: 50px;
    line-height: 109%;
    color: #3F78BD;
    text-align: center;
    span {
        font-weight: bold;
        font-size: 50px;
        line-height: 109%;
        color: #f6669e;
    }
`

const StyledContainer = styled(Box)`
    position: relative;
    z-index: 2;
    padding-top: 73.87px;
    background-image: url(${Back});
    background-size: 100% 100%;
    @media (max-width: 1100px) {
        background-size: auto 100% !important;
    }
    @media (max-width: 767px) {
        padding-top: 63px;
    }
    @media (max-width: 500px) {
        background-image: url(${BackMobile});
        background-size: 100% 100% !important;
    }
    background-repeat: no-repeat;
`

export default CharCard